declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function pushDataLayerEvent(event: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

/** Ported from typ.html.twig: {'event':'formularze','wypelniony-formularz':'newsletter-zamowiono-{slug}'}.
 *  leadId is our own requestGuid as echoed back by WLS — the identifier GA4 can be joined to CRM on. */
export function pushSubscribeSuccessEvent(slug: string, leadId?: string | null): void {
  pushDataLayerEvent({ event: 'formularze', 'wypelniony-formularz': `newsletter-zamowiono-${slug}`, leadid: leadId });
}
